import type { FC } from 'react';
import AntSkeleton from 'antd/es/skeleton';
import type { SkeletonProps } from 'antd/es/skeleton';
import { cn } from 'app/lib/utils';

export type { SkeletonProps };

export interface SkeletonBlockProps {
  className: string;
}

// A placeholder that holds an exact box open. Deliberately not `Skeleton.Node`: antd sizes its element
// from `.ant-skeleton.ant-skeleton-element` (0,2,0) and `… .ant-skeleton-image` (0,3,0), both of which
// outrank a Tailwind utility (0,1,0) — so a className on Node is applied but never wins, and the box
// renders at antd's size instead of the caller's. A bare span has no rules to fight.
//
// `className` is required because without a height this renders nothing and holds no space open,
// defeating the one thing it exists for.
const Block: FC<SkeletonBlockProps> = ({ className }) => (
  <span
    aria-hidden
    className={cn('block animate-pulse rounded bg-fill-tertiary', className)}
  />
);

// antd's Skeleton, re-exported whole so `import { Skeleton } from 'antd'` sites can swap here as-is,
// plus `Skeleton.Block` for the fixed-box case above.
export const Skeleton = AntSkeleton as typeof AntSkeleton & {
  Block: typeof Block;
};
Skeleton.Block = Block;

export default Skeleton;
